import { Modal } from 'almanac-ui/Modal'

import Styles from './VirtualMarketerPreparingModal.module.scss'
import { DeclarativeToast } from 'common/ToastMessage/DeclarativeToast'
import { ToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { OnboardingLoader } from 'screens/LoginOrSignup/components/OnboardingLoader/OnboardingLoader'

export const VirtualMarketerPreparingModal = ({ showOnboardingLoader = false }: { showOnboardingLoader?: boolean }) => {
  if (showOnboardingLoader) {
    return (
      <Modal.Root size="fullscreen">
        <OnboardingLoader fadeIn={false} fadeOut={false} />
      </Modal.Root>
    )
  }
  return (
    <Modal.Root size="fullscreen">
      <div className={Styles.container}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1749870304/virtual_marketer_onboarding/welcome_to_the_future_of_marketing_fve0xt.png"
          alt="Welcome to the future of marketing"
        />
        <DeclarativeToast>
          <ToastMessage toastMessage="Preparing workspace..." variant="loading" />
        </DeclarativeToast>
      </div>
    </Modal.Root>
  )
}
